import type { BodyUpdateTemplate } from "@/common/types/notesTemplates";
import { useVisitWrites } from "@/hooks/visits/useVisitWrites";

export const useUpdateVisitTemplate = () => {
  const { updateVisit, result, loading, error } = useVisitWrites();
  return {
    updateTemplate: (body: BodyUpdateTemplate): Promise<boolean> =>
      updateVisit({
        params: { public_id: body.public_id },
        query: {},
        body: { result: body.result },
      }),
    result,
    loading,
    error,
  };
};
